<script lang="ts">
	import __ from '$lib/stores/TranslationStore';
	import cetelem from '$lib/assets/images/partners/cetelem.svg';
	import bankinter from '$lib/assets/images/partners/bankinter.svg';
	import novobanco from '$lib/assets/images/partners/novobanco.svg';
	import CTT from '$lib/assets/images/partners/banco-ctt.svg';
	import BPI from '$lib/assets/images/partners/bpi.svg';
	import UCI from '$lib/assets/images/partners/UCI.svg';
	import CGD from '$lib/assets/images/partners/CGD.svg';
	import santander from '$lib/assets/images/partners/santander.svg';
	import abanca from '$lib/assets/images/partners/abanca.svg';
	import cofidis from '$lib/assets/images/partners/cofidis.svg';

	// import eurobic from '$lib/assets/images/partners/eurobic.svg';
	// import bancobni from '$lib/assets/images/partners/bancobni.svg';
	import asisa from '$lib/assets/images/partners/asisa.svg';
	import april from '$lib/assets/images/partners/april.svg';
	import metlife from '$lib/assets/images/partners/metlife.svg';
	import prevoir from '$lib/assets/images/partners/prevoir.svg';
	import realvidaseguros from '$lib/assets/images/partners/realvidaseguros.png';
	import generaliTranquilidade from '$lib/assets/images/partners/generali-tranquilidade.svg';
	import allianz from '$lib/assets/images/partners/allianz.svg';

	export let caption: string = $__('Intermediação com os principais bancos do país.');
	export let insurance: boolean = false;

	export let partners: Record<string, string>[] = !insurance
		? [
				{ cetelem },
				{ bankinter },
				{ novobanco },
				{ CTT },
				{ BPI },
				{ UCI },
				{ CGD },
				{ santander },
				{ abanca },
				{ cofidis, class: 'opacity-70' }
				// { eurobic: eurobic, class: 'opacity-70' },
				// { bancobni: bancobni, class: 'opacity-70' },
				// { asisa: asisa },
				// { april: april },
				// { metlife: metlife },
				// { prevoir: prevoir, class: 'opacity-70' },
				// { realvidaseguros: realvidaseguros }
		  ]
		: [
				{ asisa },
				{ april },
				{ metlife },
				{ prevoir, class: 'opacity-70' },
				{ realvidaseguros },
				{ generaliTranquilidade },
				{ allianz }
		  ];
</script>

<section>
	<div class="mb-10">
		<h1 class="text-2xl">{$__('Parceiros')}</h1>
		<p class="text-sm">{caption}</p>
	</div>
	<div class="grid grid-cols-3 items-center gap-16 grayscale sm:grid-cols-4 lg:grid-cols-5">
		{#each partners as partner, key}
			<img class=" {partner.class}" src={Object.values(partner)[0]} alt={Object.keys(partner)[0]} />
		{/each}
	</div>
</section>
